import { Route } from 'react-router-dom';

import { ChatbotsCreateView } from './views/create';

import { ChatbotsView } from './';

export const settingsIntegrationsChatbotsRoutes = (
  <Route path="chatbots">
    <Route path="" element={<ChatbotsView />} />
    <Route path="create-new" element={<ChatbotsCreateView />} />
  </Route>
);
